import React, { useState, useEffect, useRef } from "react";
import styles from "./Verification.module.scss";
import { useTranslation } from "react-i18next";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import { CircularProgress, Drawer } from "@mui/material";
import { Link, useParams } from "react-router-dom";

export default function Verification({
  theme,
  setSnackType,
  setSnackMessage,
  handleClick,
  account,
  accounts,
}) {
  const { t } = useTranslation();
  const [imgType, setImgType] = useState(0);
  const [file, setFile] = useState(null);
  const inputRef = useRef();
  const [dragActive, setDragActive] = useState(false);
  const [passportPage1Status, setPassportPage1Status] = useState(0);
  const [passportPage2Status, setPassportPage2Status] = useState(0);
  const [selfieStatus, setSelfieStatus] = useState(0);
  const [imageData, setImageData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingServer, setIsLoadingServer] = useState(false);
  const [isLoadingRequest, setIsLoadingRequest] = useState(false);
  const { id } = useParams();

  const allPending =
    passportPage1Status !== 2 ||
    passportPage2Status !== 2 ||
    selfieStatus !== 2;

  const handleSendVerificationRequest = async () => {
    try {
      setIsLoadingRequest(true);
      const { data } = await axios.get(
        process.env.REACT_APP_test_url +
          `/api/accounts/request/verification/${
            secureLocalStorage.getItem("selected_account")?.Id
          }`,
        {
          headers: {
            Authorization: "Bearer " + secureLocalStorage.getItem("token"),
          },
        }
      );
      if (data) {
        console.log(data);
        setIsLoadingRequest(false);
      }
    } catch (e) {
      console.log(e);
      setIsLoadingRequest(false);
    }
  };

  useEffect(() => {
    const passport1 = secureLocalStorage.getItem("user")?.PassportPage1;
    const passport2 = secureLocalStorage.getItem("user")?.PassportPage2;
    const selfie = secureLocalStorage.getItem("user")?.PassportSelfie;
    setPassportPage1Status(passport1);
    setPassportPage2Status(passport2);
    setSelfieStatus(selfie);
  }, [
    secureLocalStorage.getItem("user")?.PassportPage1,
    secureLocalStorage.getItem("user")?.PassportPage2,
    secureLocalStorage.getItem("user")?.PassportSelfie,
  ]);

  const handleDeleteFile = () => {
    setFile(null);
    if (inputRef.current) {
      inputRef.current.value = "";
    }
    forceInputReset();
  };

  const forceInputReset = () => {
    inputRef.current.type = "";
    inputRef.current.type = "file";
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      setFile(e.dataTransfer.files[0]);
    }
  };

  const handleChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

  const handleClickP = () => {
    document.getElementById("fileInput").click();
  };

  const handleFileNameClick = () => {
    if (file) {
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL, "_blank");
    }
  };

  useEffect(() => {
    setImageData("");
    setIsLoading(true);

    const fetchImgData = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_test_url}/api/accounts/${
            secureLocalStorage.getItem("selected_account").Id
          }/document/${imgType + 1}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${secureLocalStorage.getItem("token")}`,
            },
            responseType: "blob",
          }
        );
        setIsLoading(false);
        const blobUrl = URL.createObjectURL(response.data);
        setImageData(blobUrl); // Предполагается, что `data.url` содержит URL изображения
      } catch (e) {
        console.error(e);
      }
    };

    if (imgType !== null) {
      fetchImgData();
    }
  }, [imgType]);

  const toggleDrawer = (newOpen) => () => {
    setIsModalOpen(newOpen);
  };

  const handleFileUpload = async (event, type) => {
    if (!file) return;
    setIsLoadingServer(true)
    const formData = new FormData();
    formData.append("files", file);
    formData.append("type", type);

    try {
      const id = secureLocalStorage.getItem("user")?.Id;
      await axios.post(
        process.env.REACT_APP_test_url + `/api/users/${id}/document`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${secureLocalStorage.getItem("token")}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setIsLoadingServer(false)
      setSnackType("success");
      setSnackMessage(t("FileUploadedSuccessfully"));
      handleClick();
      handleDeleteFile();
    } catch (error) {
      setIsLoadingServer(false)
      setSnackType("error");
      setSnackMessage(t("FileUploadError"));
      handleClick();
    }
  };

  return (
    <div className={styles.verification}>
      <div className={styles.verification_title}>
        <Link to={`/cabinet`}>
          {`${
            id
              ? accounts?.find((val) => val?.Id == id)?.AccountTitle
              : account?.AccountTitle
          } /`}
        </Link>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={"1.6vh"}
          height={"1.6vh"}
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.39485 2.13417C6.2325 2.27252 6.15132 2.3417 6.06463 2.39981C5.86589 2.53301 5.6427 2.62546 5.40799 2.6718C5.30559 2.69201 5.19927 2.7005 4.98664 2.71747C4.45238 2.7601 4.18525 2.78142 3.96239 2.86014C3.44692 3.0422 3.04147 3.44766 2.8594 3.96312C2.78069 4.18599 2.75937 4.45311 2.71674 4.98737C2.69977 5.20001 2.69128 5.30632 2.67107 5.40872C2.62473 5.64343 2.53228 5.86662 2.39908 6.06536C2.34097 6.15206 2.27179 6.23323 2.13343 6.39559C1.78581 6.8035 1.61199 7.00747 1.51006 7.22072C1.27432 7.71395 1.27432 8.28735 1.51006 8.78058C1.61199 8.99383 1.7858 9.19779 2.13343 9.60571C2.27178 9.76805 2.34097 9.84925 2.39908 9.93594C2.53228 10.1347 2.62473 10.3579 2.67107 10.5926C2.69128 10.695 2.69977 10.8013 2.71674 11.0139C2.75937 11.5482 2.78069 11.8153 2.8594 12.0382C3.04147 12.5536 3.44692 12.9591 3.96239 13.1412C4.18525 13.2199 4.45238 13.2412 4.98664 13.2838C5.19927 13.3008 5.30559 13.3093 5.40799 13.3295C5.6427 13.3758 5.86589 13.4683 6.06463 13.6015C6.15132 13.6596 6.2325 13.7288 6.39485 13.8671C6.80278 14.2148 7.00674 14.3886 7.21999 14.4905C7.71322 14.7263 8.28662 14.7263 8.77985 14.4905C8.9931 14.3886 9.19706 14.2148 9.60498 13.8671C9.76734 13.7288 9.84851 13.6596 9.93521 13.6015C10.1339 13.4683 10.3571 13.3758 10.5919 13.3295C10.6942 13.3093 10.8006 13.3008 11.0132 13.2838C11.5475 13.2412 11.8146 13.2199 12.0374 13.1412C12.5529 12.9591 12.9584 12.5536 13.1404 12.0382C13.2192 11.8153 13.2405 11.5482 13.2831 11.0139C13.3001 10.8013 13.3086 10.695 13.3288 10.5926C13.3751 10.3579 13.4676 10.1347 13.6008 9.93594C13.6589 9.84925 13.728 9.76807 13.8664 9.60571C14.214 9.19779 14.3878 8.99383 14.4898 8.78058C14.7255 8.28735 14.7255 7.71395 14.4898 7.22072C14.3878 7.00747 14.214 6.80351 13.8664 6.39559C13.728 6.23323 13.6589 6.15206 13.6008 6.06536C13.4676 5.86662 13.3751 5.64343 13.3288 5.40872C13.3086 5.30632 13.3001 5.20001 13.2831 4.98737C13.2405 4.45311 13.2192 4.18599 13.1404 3.96312C12.9584 3.44766 12.5529 3.0422 12.0374 2.86014C11.8146 2.78142 11.5475 2.7601 11.0132 2.71747C10.8006 2.7005 10.6942 2.69201 10.5919 2.6718C10.3571 2.62546 10.1339 2.53301 9.93521 2.39981C9.84851 2.3417 9.76734 2.27252 9.60498 2.13417C9.19706 1.78654 8.9931 1.61272 8.77985 1.51079C8.28662 1.27505 7.71322 1.27505 7.21999 1.51079C7.00674 1.61272 6.80277 1.78654 6.39485 2.13417ZM10.9156 6.57608C11.1275 6.36419 11.1275 6.02065 10.9156 5.80876C10.7037 5.59687 10.3602 5.59687 10.1483 5.80876L6.91476 9.04226L5.85156 7.97905C5.63967 7.76717 5.29613 7.76717 5.08424 7.97905C4.87236 8.19094 4.87236 8.53448 5.08424 8.74637L6.53111 10.1932C6.74299 10.4051 7.08653 10.4051 7.29842 10.1932L10.9156 6.57608Z"
            fill="#FCFCFC"
          />
        </svg>
        <span>{t("Verification")}</span>
      </div>
      <div className={styles.verification_body}>
        <div className={styles.verification_form}>
          <div className={styles.verification_form_title}>
            {t("Verify your identity")}
            {(passportPage1Status !== 0 ||
              passportPage2Status !== 0 ||
              selfieStatus !== 0 ) &&
              allPending &&
              (secureLocalStorage.getItem("user").IsVerified === 0 ||
                secureLocalStorage.getItem("user").IsVerified === 3) && (
                  isLoadingRequest ? (
                    <CircularProgress color="secondary" />
                  ) : (
                  <button
                  onClick={handleSendVerificationRequest}
                  style={{
                    borderRadius: "1000px",
                    background: "var(--Brand-main, #52A5E5)",
                    display: "flex",
                    padding: "12px",
                    fontFamily: "Inter,sans-serif",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#FFFFFF",
                    fontWeight: "600",
                    fontSize: "14px",
                    cursor: "pointer",
                    border: "none",
                    outline: "none",
                  }}
                >
                  {t("Verify")}
                </button>
                )
              )}
            {secureLocalStorage.getItem("user")?.IsVerified === 1 && (
              <div
                className={styles.right_side}
                style={{
                  padding: "0 12px",
                  color: "#E9770E",
                  background: "rgba(233, 119, 14, 0.08)",
                  borderRadius: "1000px",
                  fontSize: "14px",
                }}
              >
                {t("Pending")}
              </div>
            )}
            {secureLocalStorage.getItem("user")?.IsVerified === 2 && (
              <div
                className={styles.right_side}
                style={{
                  padding: "0 12px",
                  color: "#00B4A0",
                  background: "rgba(0, 180, 160, 0.08)",
                  borderRadius: "1000px",
                  fontSize: "14px",
                }}
              >
                {t("Verified")}
              </div>
            )}
            {/* {secureLocalStorage.getItem('user')?.IsVerified === 3 && (
              <div
                className={styles.right_side}
                style={{
                  padding: "0 12px",
                  color: "#F63D68",
                  background: "rgba(246, 61, 104, 0.08)",
                  borderRadius: "1000px",
                  fontSize: "14px",
                }}
              >
                {t("Declined")}
              </div>
            )} */}
          </div>
          <div className={styles.verification_type}>
            <div
              className={`${styles.type} ${imgType === 0 ? styles.active : ""}`}
              onClick={() => setImgType(0)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
              >
                <path
                  d="M4.5 6V19C4.5 20.6569 5.84315 22 7.5 22H17.5C19.1569 22 20.5 20.6569 20.5 19V9C20.5 7.34315 19.1569 6 17.5 6H4.5ZM4.5 6V5"
                  stroke="#FCFCFC"
                />
                <circle cx="12.5" cy="13" r="3" stroke="#FCFCFC" />
                <path
                  d="M18.5 5.99904V6.49904H19V5.99904H18.5ZM16.2172 2.32516L16.1464 1.83019L16.2172 2.32516ZM5.41959 3.86767L5.34888 3.3727H5.34888L5.41959 3.86767ZM5.57107 6.49904H18.5V5.49904H5.57107V6.49904ZM19 5.99904V4.30506H18V5.99904H19ZM16.1464 1.83019L5.34888 3.3727L5.49031 4.36265L16.2879 2.82014L16.1464 1.83019ZM5.34888 3.3727C4.5749 3.48327 4 4.14613 4 4.92798H5C5 4.64378 5.20897 4.40284 5.49031 4.36265L5.34888 3.3727ZM19 4.30506C19 2.78369 17.6525 1.61503 16.1464 1.83019L16.2879 2.82014C17.1915 2.69105 18 3.39224 18 4.30506H19ZM5.57107 5.49904C5.25568 5.49904 5 5.24337 5 4.92798H4C4 5.79565 4.70339 6.49904 5.57107 6.49904V5.49904Z"
                  fill="#FCFCFC"
                />
                <path
                  d="M10.5 19H14.5"
                  stroke="#FCFCFC"
                  strokeLinecap="round"
                />
              </svg>
              {t("Passport 1st")}
            </div>
            <div
              className={`${styles.type} ${imgType === 1 ? styles.active : ""}`}
              onClick={() => setImgType(1)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
              >
                <path
                  d="M4.5 6V19C4.5 20.6569 5.84315 22 7.5 22H17.5C19.1569 22 20.5 20.6569 20.5 19V9C20.5 7.34315 19.1569 6 17.5 6H4.5ZM4.5 6V5"
                  stroke="#FCFCFC"
                />
                <circle cx="12.5" cy="13" r="3" stroke="#FCFCFC" />
                <path
                  d="M18.5 5.99904V6.49904H19V5.99904H18.5ZM16.2172 2.32516L16.1464 1.83019L16.2172 2.32516ZM5.41959 3.86767L5.34888 3.3727H5.34888L5.41959 3.86767ZM5.57107 6.49904H18.5V5.49904H5.57107V6.49904ZM19 5.99904V4.30506H18V5.99904H19ZM16.1464 1.83019L5.34888 3.3727L5.49031 4.36265L16.2879 2.82014L16.1464 1.83019ZM5.34888 3.3727C4.5749 3.48327 4 4.14613 4 4.92798H5C5 4.64378 5.20897 4.40284 5.49031 4.36265L5.34888 3.3727ZM19 4.30506C19 2.78369 17.6525 1.61503 16.1464 1.83019L16.2879 2.82014C17.1915 2.69105 18 3.39224 18 4.30506H19ZM5.57107 5.49904C5.25568 5.49904 5 5.24337 5 4.92798H4C4 5.79565 4.70339 6.49904 5.57107 6.49904V5.49904Z"
                  fill="#FCFCFC"
                />
                <path
                  d="M10.5 19H14.5"
                  stroke="#FCFCFC"
                  strokeLinecap="round"
                />
              </svg>
              {t("Passport 2nd")}
            </div>
            <div
              className={`${styles.type} ${imgType === 2 ? styles.active : ""}`}
              onClick={() => setImgType(2)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <circle
                  cx="9"
                  cy="9"
                  r="2"
                  stroke="#1C274C"
                  strokeWidth="1.5"
                />
                <path
                  d="M13 15C13 16.1046 13 17 9 17C5 17 5 16.1046 5 15C5 13.8954 6.79086 13 9 13C11.2091 13 13 13.8954 13 15Z"
                  stroke="#1C274C"
                  strokeWidth="1.5"
                />
                <path
                  d="M2 12C2 8.22876 2 6.34315 3.17157 5.17157C4.34315 4 6.22876 4 10 4H14C17.7712 4 19.6569 4 20.8284 5.17157C22 6.34315 22 8.22876 22 12C22 15.7712 22 17.6569 20.8284 18.8284C19.6569 20 17.7712 20 14 20H10C6.22876 20 4.34315 20 3.17157 18.8284C2 17.6569 2 15.7712 2 12Z"
                  stroke="#1C274C"
                  strokeWidth="1.5"
                />
                <path
                  d="M19 12H15"
                  stroke="#1C274C"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                <path
                  d="M19 9H14"
                  stroke="#1C274C"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                <path
                  d="M19 15H16"
                  stroke="#1C274C"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
              </svg>
              {t("Selfie")}
            </div>
          </div>
          {(imgType == 0 &&
            (secureLocalStorage.getItem("user")?.PassportPage1 == 2 ||
              secureLocalStorage.getItem("user")?.IsVerified == 1 || secureLocalStorage.getItem("user")?.IsVerified == 2)) ||
          (imgType == 1 &&
            (secureLocalStorage.getItem("user")?.PassportPage2 == 2 ||
              secureLocalStorage.getItem("user")?.IsVerified == 1 || secureLocalStorage.getItem("user")?.IsVerified == 2)) ||
          (imgType == 2 &&
            (secureLocalStorage.getItem("user")?.PassportSelfie == 2 ||
              secureLocalStorage.getItem("user")?.IsVerified == 1 || secureLocalStorage.getItem("user")?.IsVerified == 2)) ? null : (
            <div
              className={`${styles.dnd} ${dragActive ? styles.dragActive : ""}`}
              onDragEnter={handleDrag}
              onDragOver={handleDrag}
              onDragLeave={handleDrag}
              onDrop={handleDrop}
              onClick={handleClickP}
              
            >
              <input
                id="fileInput"
                type="file"
                accept="image/*,.heic,.heif" // Включены HEIC и HEIF
                style={{ display: "none" }}
                onChange={handleChange}
                ref={inputRef}
              />
              <div className={styles.dnd_body}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={"2.5vh"}
                  height={"2.4vh"}
                  viewBox="0 0 25 24"
                  fill="none"
                >
                  <path
                    d="M12.25 4.9318V3.64393L11.381 4.59442L8.68451 7.54369C8.59134 7.64559 8.43321 7.65267 8.33131 7.55951C8.22941 7.46634 8.22233 7.30821 8.31549 7.20631L12.3155 2.83131C12.3629 2.77951 12.4298 2.75 12.5 2.75C12.5702 2.75 12.6371 2.77951 12.6845 2.83131L16.6845 7.20631C16.7777 7.30821 16.7706 7.46634 16.6687 7.55951C16.5668 7.65267 16.4087 7.64559 16.3155 7.54369L13.619 4.59442L12.75 3.64393V4.9318V16C12.75 16.1381 12.6381 16.25 12.5 16.25C12.3619 16.25 12.25 16.1381 12.25 16V4.9318ZM3.5 14.75C3.63807 14.75 3.75 14.8619 3.75 15C3.75 16.421 3.75052 17.462 3.85761 18.2585C3.96376 19.0481 4.17047 19.5596 4.55546 19.9445C4.94045 20.3295 5.45195 20.5362 6.2415 20.6424C7.03797 20.7495 8.079 20.75 9.5 20.75H15.5C16.921 20.75 17.962 20.7495 18.7585 20.6424C19.5481 20.5362 20.0596 20.3295 20.4445 19.9445C20.8295 19.5596 21.0362 19.0481 21.1424 18.2585C21.2495 17.462 21.25 16.421 21.25 15C21.25 14.8619 21.3619 14.75 21.5 14.75C21.6381 14.75 21.75 14.8619 21.75 15V15.0549C21.75 16.4355 21.749 17.499 21.6379 18.3251C21.5243 19.17 21.2915 19.8047 20.7981 20.2981C20.3047 20.7915 19.67 21.0243 18.8251 21.1379C17.999 21.249 16.9355 21.25 15.5549 21.25H9.44513C8.0645 21.25 7.00104 21.249 6.17487 21.1379C5.33001 21.0243 4.69534 20.7915 4.2019 20.2981C3.70847 19.8047 3.47565 19.17 3.36207 18.3251C3.25099 17.499 3.24998 16.4355 3.25 15.0549V15C3.25 14.8619 3.36193 14.75 3.5 14.75Z"
                    stroke="#51525C"
                  />
                </svg>
                <p>
                  <span>{t("Click to upload")}</span> {t("or drag and drop")}
                </p>
                <p className={styles.formats}>
                  PDF, JPG, JPEG, PNG, HEIC less than 10MB.
                  {t("Ensure your document are in good condition and readable")}
                </p>
              </div>
            </div>
          )}
          {imgType === 0 &&
          file &&
          (secureLocalStorage.getItem("user")?.PassportPage1 == 3 ||
            !secureLocalStorage.getItem("user")?.PassportPage1) ? (
            <div className={styles.fileInfo}>
              <div className={styles.left_side}>
                <span className={styles.icon}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={"2.5vh"}
                    height={"2.4vh"}
                    viewBox="0 0 25 24"
                    fill="none"
                  >
                    <path
                      d="M4.5 6V19C4.5 20.6569 5.84315 22 7.5 22H17.5C19.1569 22 20.5 20.6569 20.5 19V9C20.5 7.34315 19.1569 6 17.5 6H4.5ZM4.5 6V5"
                      stroke="#FCFCFC"
                    />
                    <circle cx="12.5" cy="13" r="3" stroke="#FCFCFC" />
                    <path
                      d="M18.5 5.99904V6.49904H19V5.99904H18.5ZM16.2172 2.32516L16.1464 1.83019L16.2172 2.32516ZM5.41959 3.86767L5.34888 3.3727H5.34888L5.41959 3.86767ZM5.57107 6.49904H18.5V5.49904H5.57107V6.49904ZM19 5.99904V4.30506H18V5.99904H19ZM16.1464 1.83019L5.34888 3.3727L5.49031 4.36265L16.2879 2.82014L16.1464 1.83019ZM5.34888 3.3727C4.5749 3.48327 4 4.14613 4 4.92798H5C5 4.64378 5.20897 4.40284 5.49031 4.36265L5.34888 3.3727ZM19 4.30506C19 2.78369 17.6525 1.61503 16.1464 1.83019L16.2879 2.82014C17.1915 2.69105 18 3.39224 18 4.30506H19ZM5.57107 5.49904C5.25568 5.49904 5 5.24337 5 4.92798H4C4 5.79565 4.70339 6.49904 5.57107 6.49904V5.49904Z"
                      fill="#FCFCFC"
                    />
                    <path
                      d="M10.5 19H14.5"
                      stroke="#FCFCFC"
                      strokeLinecap="round"
                    />
                  </svg>
                </span>
                <span className={styles.name}>
                  <p>
                    {imgType == 0
                      ? t("Passport 1st")
                      : imgType == 1
                      ? t("Passport 2nd")
                      : t("Selfie")}
                  </p>
                  <span onClick={handleFileNameClick}>
                    {file.name}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={"1.6vh"}
                      height={"1.6vh"}
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M14.6666 8.00065C14.6666 11.6825 11.6818 14.6673 7.99992 14.6673C4.31802 14.6673 1.33325 11.6825 1.33325 8.00065C1.33325 4.31875 4.31802 1.33398 7.99992 1.33398C11.6818 1.33398 14.6666 4.31875 14.6666 8.00065ZM10.6868 5.98043C10.8821 6.17569 10.8821 6.49228 10.6868 6.68754L7.35347 10.0209C7.15821 10.2161 6.84163 10.2161 6.64637 10.0209L5.31303 8.68754C5.11777 8.49228 5.11777 8.17569 5.31303 7.98043C5.50829 7.78517 5.82488 7.78517 6.02014 7.98043L6.99992 8.96021L8.48981 7.47032L9.9797 5.98043C10.175 5.78517 10.4915 5.78517 10.6868 5.98043Z"
                        fill="#00B4A0"
                      />
                    </svg>
                  </span>
                </span>
              </div>
              {isLoadingServer ? (
                <div className={styles.right_side}>
                  <CircularProgress color="secondary" />
                </div>
              ) : (
                <div className={styles.right_side}>
                  <button onClick={handleDeleteFile} className={styles.delete}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={"2.4vh"}
                      height={"2.4vh"}
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M20.5001 6H3.5"
                        stroke="#FCFCFC"
                        strokeLinecap="round"
                      />
                      <path
                        d="M18.8332 8.5L18.3732 15.3991C18.1962 18.054 18.1077 19.3815 17.2427 20.1907C16.3777 21 15.0473 21 12.3865 21H11.6132C8.95235 21 7.62195 21 6.75694 20.1907C5.89194 19.3815 5.80344 18.054 5.62644 15.3991L5.1665 8.5"
                        stroke="#FCFCFC"
                        strokeLinecap="round"
                      />
                      <path
                        d="M9.1709 4C9.58273 2.83481 10.694 2 12.0002 2C13.3064 2 14.4177 2.83481 14.8295 4"
                        stroke="#FCFCFC"
                        strokeLinecap="round"
                      />
                    </svg>
                  </button>
                  <button
                    className={styles.send}
                    onClick={(e) => {
                      handleFileUpload(e, imgType + 1);
                    }}
                  >
                    Send
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={"1.6vh"}
                      height={"1.6vh"}
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M2.99847 13.89L14.005 8.98169C14.8875 8.58814 14.8875 7.41186 14.005 7.01831L2.99847 2.10997C2.00125 1.66526 0.966872 2.65276 1.46083 3.57793L3.56218 7.51374C3.72561 7.81985 3.72561 8.18015 3.56218 8.48626L1.46083 12.4221C0.966873 13.3472 2.00125 14.3347 2.99847 13.89Z"
                        fill="#A855F7"
                      />
                    </svg>
                  </button>
                </div>
              )}
              </div>
          ) : null}
          {imgType === 1 &&
          file &&
          (secureLocalStorage.getItem("user")?.PassportPage2 == 3 ||
            !secureLocalStorage.getItem("user")?.PassportPage2) ? (
            <div className={styles.fileInfo}>
              <div className={styles.left_side}>
                <span className={styles.icon}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={"2.5vh"}
                    height={"2.4vh"}
                    viewBox="0 0 25 24"
                    fill="none"
                  >
                    <path
                      d="M4.5 6V19C4.5 20.6569 5.84315 22 7.5 22H17.5C19.1569 22 20.5 20.6569 20.5 19V9C20.5 7.34315 19.1569 6 17.5 6H4.5ZM4.5 6V5"
                      stroke="#FCFCFC"
                    />
                    <circle cx="12.5" cy="13" r="3" stroke="#FCFCFC" />
                    <path
                      d="M18.5 5.99904V6.49904H19V5.99904H18.5ZM16.2172 2.32516L16.1464 1.83019L16.2172 2.32516ZM5.41959 3.86767L5.34888 3.3727H5.34888L5.41959 3.86767ZM5.57107 6.49904H18.5V5.49904H5.57107V6.49904ZM19 5.99904V4.30506H18V5.99904H19ZM16.1464 1.83019L5.34888 3.3727L5.49031 4.36265L16.2879 2.82014L16.1464 1.83019ZM5.34888 3.3727C4.5749 3.48327 4 4.14613 4 4.92798H5C5 4.64378 5.20897 4.40284 5.49031 4.36265L5.34888 3.3727ZM19 4.30506C19 2.78369 17.6525 1.61503 16.1464 1.83019L16.2879 2.82014C17.1915 2.69105 18 3.39224 18 4.30506H19ZM5.57107 5.49904C5.25568 5.49904 5 5.24337 5 4.92798H4C4 5.79565 4.70339 6.49904 5.57107 6.49904V5.49904Z"
                      fill="#FCFCFC"
                    />
                    <path
                      d="M10.5 19H14.5"
                      stroke="#FCFCFC"
                      strokeLinecap="round"
                    />
                  </svg>
                </span>
                <span className={styles.name}>
                  <p>
                    {imgType == 0
                      ? t("Passport 1st")
                      : imgType == 1
                      ? t("Passport 2nd")
                      : t("Selfie")}
                  </p>
                  <span onClick={handleFileNameClick}>
                    {file.name}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={"1.6vh"}
                      height={"1.6vh"}
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M14.6666 8.00065C14.6666 11.6825 11.6818 14.6673 7.99992 14.6673C4.31802 14.6673 1.33325 11.6825 1.33325 8.00065C1.33325 4.31875 4.31802 1.33398 7.99992 1.33398C11.6818 1.33398 14.6666 4.31875 14.6666 8.00065ZM10.6868 5.98043C10.8821 6.17569 10.8821 6.49228 10.6868 6.68754L7.35347 10.0209C7.15821 10.2161 6.84163 10.2161 6.64637 10.0209L5.31303 8.68754C5.11777 8.49228 5.11777 8.17569 5.31303 7.98043C5.50829 7.78517 5.82488 7.78517 6.02014 7.98043L6.99992 8.96021L8.48981 7.47032L9.9797 5.98043C10.175 5.78517 10.4915 5.78517 10.6868 5.98043Z"
                        fill="#00B4A0"
                      />
                    </svg>
                  </span>
                </span>
              </div>
              
              {isLoadingServer ? (
                <div className={styles.right_side}>
                  <CircularProgress color="secondary" />
                </div>
              ) : (
              <div className={styles.right_side}>
                <button onClick={handleDeleteFile} className={styles.delete}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={"2.4vh"}
                    height={"2.4vh"}
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M20.5001 6H3.5"
                      stroke="#FCFCFC"
                      strokeLinecap="round"
                    />
                    <path
                      d="M18.8332 8.5L18.3732 15.3991C18.1962 18.054 18.1077 19.3815 17.2427 20.1907C16.3777 21 15.0473 21 12.3865 21H11.6132C8.95235 21 7.62195 21 6.75694 20.1907C5.89194 19.3815 5.80344 18.054 5.62644 15.3991L5.1665 8.5"
                      stroke="#FCFCFC"
                      strokeLinecap="round"
                    />
                    <path
                      d="M9.1709 4C9.58273 2.83481 10.694 2 12.0002 2C13.3064 2 14.4177 2.83481 14.8295 4"
                      stroke="#FCFCFC"
                      strokeLinecap="round"
                    />
                  </svg>
                </button>
                <button
                  className={styles.send}
                  onClick={(e) => {
                    handleFileUpload(e, imgType + 1);
                  }}
                >
                  Send
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={"1.6vh"}
                    height={"1.6vh"}
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M2.99847 13.89L14.005 8.98169C14.8875 8.58814 14.8875 7.41186 14.005 7.01831L2.99847 2.10997C2.00125 1.66526 0.966872 2.65276 1.46083 3.57793L3.56218 7.51374C3.72561 7.81985 3.72561 8.18015 3.56218 8.48626L1.46083 12.4221C0.966873 13.3472 2.00125 14.3347 2.99847 13.89Z"
                      fill="#A855F7"
                    />
                  </svg>
                </button>
              </div>
              
              )}
            </div>
          ) : null}
          {imgType === 2 &&
          file &&
          (secureLocalStorage.getItem("user")?.PassportSelfie == 3 ||
            !secureLocalStorage.getItem("user")?.PassportSelfie) ? (
            <div className={styles.fileInfo}>
              <div className={styles.left_side}>
                <span className={styles.icon}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={"2.5vh"}
                    height={"2.4vh"}
                    viewBox="0 0 25 24"
                    fill="none"
                  >
                    <path
                      d="M4.5 6V19C4.5 20.6569 5.84315 22 7.5 22H17.5C19.1569 22 20.5 20.6569 20.5 19V9C20.5 7.34315 19.1569 6 17.5 6H4.5ZM4.5 6V5"
                      stroke="#FCFCFC"
                    />
                    <circle cx="12.5" cy="13" r="3" stroke="#FCFCFC" />
                    <path
                      d="M18.5 5.99904V6.49904H19V5.99904H18.5ZM16.2172 2.32516L16.1464 1.83019L16.2172 2.32516ZM5.41959 3.86767L5.34888 3.3727H5.34888L5.41959 3.86767ZM5.57107 6.49904H18.5V5.49904H5.57107V6.49904ZM19 5.99904V4.30506H18V5.99904H19ZM16.1464 1.83019L5.34888 3.3727L5.49031 4.36265L16.2879 2.82014L16.1464 1.83019ZM5.34888 3.3727C4.5749 3.48327 4 4.14613 4 4.92798H5C5 4.64378 5.20897 4.40284 5.49031 4.36265L5.34888 3.3727ZM19 4.30506C19 2.78369 17.6525 1.61503 16.1464 1.83019L16.2879 2.82014C17.1915 2.69105 18 3.39224 18 4.30506H19ZM5.57107 5.49904C5.25568 5.49904 5 5.24337 5 4.92798H4C4 5.79565 4.70339 6.49904 5.57107 6.49904V5.49904Z"
                      fill="#FCFCFC"
                    />
                    <path
                      d="M10.5 19H14.5"
                      stroke="#FCFCFC"
                      strokeLinecap="round"
                    />
                  </svg>
                </span>
                <span className={styles.name}>
                  <p>
                    {imgType == 0
                      ? t("Passport 1st")
                      : imgType == 1
                      ? t("Passport 2nd")
                      : t("Selfie")}
                  </p>
                  <span onClick={handleFileNameClick}>
                    {file.name}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={"1.6vh"}
                      height={"1.6vh"}
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M14.6666 8.00065C14.6666 11.6825 11.6818 14.6673 7.99992 14.6673C4.31802 14.6673 1.33325 11.6825 1.33325 8.00065C1.33325 4.31875 4.31802 1.33398 7.99992 1.33398C11.6818 1.33398 14.6666 4.31875 14.6666 8.00065ZM10.6868 5.98043C10.8821 6.17569 10.8821 6.49228 10.6868 6.68754L7.35347 10.0209C7.15821 10.2161 6.84163 10.2161 6.64637 10.0209L5.31303 8.68754C5.11777 8.49228 5.11777 8.17569 5.31303 7.98043C5.50829 7.78517 5.82488 7.78517 6.02014 7.98043L6.99992 8.96021L8.48981 7.47032L9.9797 5.98043C10.175 5.78517 10.4915 5.78517 10.6868 5.98043Z"
                        fill="#00B4A0"
                      />
                    </svg>
                  </span>
                </span>
              </div>
              
              {isLoadingServer ? (
                <div className={styles.right_side}>
                  <CircularProgress color="secondary" />
                </div>
              ) : (
              <div className={styles.right_side}>
                <button onClick={handleDeleteFile} className={styles.delete}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={"2.4vh"}
                    height={"2.4vh"}
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M20.5001 6H3.5"
                      stroke="#FCFCFC"
                      strokeLinecap="round"
                    />
                    <path
                      d="M18.8332 8.5L18.3732 15.3991C18.1962 18.054 18.1077 19.3815 17.2427 20.1907C16.3777 21 15.0473 21 12.3865 21H11.6132C8.95235 21 7.62195 21 6.75694 20.1907C5.89194 19.3815 5.80344 18.054 5.62644 15.3991L5.1665 8.5"
                      stroke="#FCFCFC"
                      strokeLinecap="round"
                    />
                    <path
                      d="M9.1709 4C9.58273 2.83481 10.694 2 12.0002 2C13.3064 2 14.4177 2.83481 14.8295 4"
                      stroke="#FCFCFC"
                      strokeLinecap="round"
                    />
                  </svg>
                </button>
                <button
                  className={styles.send}
                  onClick={(e) => {
                    handleFileUpload(e, imgType + 1);
                  }}
                >
                  Send
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={"1.6vh"}
                    height={"1.6vh"}
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M2.99847 13.89L14.005 8.98169C14.8875 8.58814 14.8875 7.41186 14.005 7.01831L2.99847 2.10997C2.00125 1.66526 0.966872 2.65276 1.46083 3.57793L3.56218 7.51374C3.72561 7.81985 3.72561 8.18015 3.56218 8.48626L1.46083 12.4221C0.966873 13.3472 2.00125 14.3347 2.99847 13.89Z"
                      fill="#A855F7"
                    />
                  </svg>
                </button>
              </div>
              
              )}
            </div>
          ) : null}
          {imgType === 0 &&
          secureLocalStorage.getItem("user")?.PassportPage1 !== 0 ? (
            <div className={styles.fileInfo}>
              <div className={styles.left_side} onClick={toggleDrawer(true)}>
                <span className={styles.icon}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={"2.5vh"}
                    height={"2.4vh"}
                    viewBox="0 0 25 24"
                    fill="none"
                  >
                    <path
                      d="M4.5 6V19C4.5 20.6569 5.84315 22 7.5 22H17.5C19.1569 22 20.5 20.6569 20.5 19V9C20.5 7.34315 19.1569 6 17.5 6H4.5ZM4.5 6V5"
                      stroke="#FCFCFC"
                    />
                    <circle cx="12.5" cy="13" r="3" stroke="#FCFCFC" />
                    <path
                      d="M18.5 5.99904V6.49904H19V5.99904H18.5ZM16.2172 2.32516L16.1464 1.83019L16.2172 2.32516ZM5.41959 3.86767L5.34888 3.3727H5.34888L5.41959 3.86767ZM5.57107 6.49904H18.5V5.49904H5.57107V6.49904ZM19 5.99904V4.30506H18V5.99904H19ZM16.1464 1.83019L5.34888 3.3727L5.49031 4.36265L16.2879 2.82014L16.1464 1.83019ZM5.34888 3.3727C4.5749 3.48327 4 4.14613 4 4.92798H5C5 4.64378 5.20897 4.40284 5.49031 4.36265L5.34888 3.3727ZM19 4.30506C19 2.78369 17.6525 1.61503 16.1464 1.83019L16.2879 2.82014C17.1915 2.69105 18 3.39224 18 4.30506H19ZM5.57107 5.49904C5.25568 5.49904 5 5.24337 5 4.92798H4C4 5.79565 4.70339 6.49904 5.57107 6.49904V5.49904Z"
                      fill="#FCFCFC"
                    />
                    <path
                      d="M10.5 19H14.5"
                      stroke="#FCFCFC"
                      strokeLinecap="round"
                    />
                  </svg>
                </span>
                <span className={styles.name}>
                  <p>
                    {imgType == 0
                      ? t("Passport 1st")
                      : imgType == 1
                      ? t("Passport 2nd")
                      : t("Selfie")}
                  </p>
                </span>
              </div>
              {passportPage1Status === 1 && (
                <div
                  className={styles.right_side}
                  style={{
                    padding: "12px",
                    color: "#E9770E",
                    background: "rgba(233, 119, 14, 0.08)",
                    borderRadius: "1000px",
                    fontSize: "14px",
                    fontWeight: "600",
                  }}
                >
                  {t("Pending")}
                </div>
              )}
              {passportPage1Status === 2 && (
                <div
                  className={styles.right_side}
                  style={{
                    padding: "12px",
                    color: "#00B4A0",
                    background: "rgba(0, 180, 160, 0.08)",
                    borderRadius: "1000px",
                    fontSize: "14px",
                    fontWeight: "600",
                  }}
                >
                  {t("Successful")}
                </div>
              )}
              {passportPage1Status === 3 && (
                <div
                  className={styles.right_side}
                  style={{
                    padding: "12px",
                    color: "#F63D68",
                    background: "rgba(246, 61, 104, 0.08)",
                    borderRadius: "1000px",
                    fontSize: "14px",
                    fontWeight: "600",
                  }}
                >
                  {t("Reject")}
                </div>
              )}
            </div>
          ) : null}

          {imgType === 1 &&
          secureLocalStorage.getItem("user")?.PassportPage2 ? (
            <div className={styles.fileInfo}>
              <div className={styles.left_side} onClick={toggleDrawer(true)}>
                <span className={styles.icon}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={"2.5vh"}
                    height={"2.4vh"}
                    viewBox="0 0 25 24"
                    fill="none"
                  >
                    <path
                      d="M4.5 6V19C4.5 20.6569 5.84315 22 7.5 22H17.5C19.1569 22 20.5 20.6569 20.5 19V9C20.5 7.34315 19.1569 6 17.5 6H4.5ZM4.5 6V5"
                      stroke="#FCFCFC"
                    />
                    <circle cx="12.5" cy="13" r="3" stroke="#FCFCFC" />
                    <path
                      d="M18.5 5.99904V6.49904H19V5.99904H18.5ZM16.2172 2.32516L16.1464 1.83019L16.2172 2.32516ZM5.41959 3.86767L5.34888 3.3727H5.34888L5.41959 3.86767ZM5.57107 6.49904H18.5V5.49904H5.57107V6.49904ZM19 5.99904V4.30506H18V5.99904H19ZM16.1464 1.83019L5.34888 3.3727L5.49031 4.36265L16.2879 2.82014L16.1464 1.83019ZM5.34888 3.3727C4.5749 3.48327 4 4.14613 4 4.92798H5C5 4.64378 5.20897 4.40284 5.49031 4.36265L5.34888 3.3727ZM19 4.30506C19 2.78369 17.6525 1.61503 16.1464 1.83019L16.2879 2.82014C17.1915 2.69105 18 3.39224 18 4.30506H19ZM5.57107 5.49904C5.25568 5.49904 5 5.24337 5 4.92798H4C4 5.79565 4.70339 6.49904 5.57107 6.49904V5.49904Z"
                      fill="#FCFCFC"
                    />
                    <path
                      d="M10.5 19H14.5"
                      stroke="#FCFCFC"
                      strokeLinecap="round"
                    />
                  </svg>
                </span>
                <span className={styles.name}>
                  <p>
                    {imgType == 0
                      ? t("Passport 1st")
                      : imgType == 1
                      ? t("Passport 2nd")
                      : t("Selfie")}
                  </p>
                </span>
              </div>
              {passportPage2Status === 1 && (
                <div
                  className={styles.right_side}
                  style={{
                    padding: "12px",
                    color: "#E9770E",
                    background: "rgba(233, 119, 14, 0.08)",
                    borderRadius: "1000px",
                    fontSize: "14px",
                    fontWeight: "600",
                  }}
                >
                  {t("Pending")}
                </div>
              )}
              {passportPage2Status === 2 && (
                <div
                  className={styles.right_side}
                  style={{
                    padding: "12px",
                    color: "#00B4A0",
                    background: "rgba(0, 180, 160, 0.08)",
                    borderRadius: "1000px",
                    fontSize: "14px",
                    fontWeight: "600",
                  }}
                >
                  {t("Successful")}
                </div>
              )}
              {passportPage2Status === 3 && (
                <div
                  className={styles.right_side}
                  style={{
                    padding: "12px",
                    color: "#F63D68",
                    background: "rgba(246, 61, 104, 0.08)",
                    borderRadius: "1000px",
                    fontSize: "14px",
                    fontWeight: "600",
                  }}
                >
                  {t("Reject")}
                </div>
              )}
            </div>
          ) : null}
          {imgType === 2 &&
          secureLocalStorage.getItem("user")?.PassportSelfie ? (
            <div className={styles.fileInfo}>
              <div className={styles.left_side} onClick={toggleDrawer(true)}>
                <span className={styles.icon}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={"2.5vh"}
                    height={"2.4vh"}
                    viewBox="0 0 25 24"
                    fill="none"
                  >
                    <path
                      d="M4.5 6V19C4.5 20.6569 5.84315 22 7.5 22H17.5C19.1569 22 20.5 20.6569 20.5 19V9C20.5 7.34315 19.1569 6 17.5 6H4.5ZM4.5 6V5"
                      stroke="#FCFCFC"
                    />
                    <circle cx="12.5" cy="13" r="3" stroke="#FCFCFC" />
                    <path
                      d="M18.5 5.99904V6.49904H19V5.99904H18.5ZM16.2172 2.32516L16.1464 1.83019L16.2172 2.32516ZM5.41959 3.86767L5.34888 3.3727H5.34888L5.41959 3.86767ZM5.57107 6.49904H18.5V5.49904H5.57107V6.49904ZM19 5.99904V4.30506H18V5.99904H19ZM16.1464 1.83019L5.34888 3.3727L5.49031 4.36265L16.2879 2.82014L16.1464 1.83019ZM5.34888 3.3727C4.5749 3.48327 4 4.14613 4 4.92798H5C5 4.64378 5.20897 4.40284 5.49031 4.36265L5.34888 3.3727ZM19 4.30506C19 2.78369 17.6525 1.61503 16.1464 1.83019L16.2879 2.82014C17.1915 2.69105 18 3.39224 18 4.30506H19ZM5.57107 5.49904C5.25568 5.49904 5 5.24337 5 4.92798H4C4 5.79565 4.70339 6.49904 5.57107 6.49904V5.49904Z"
                      fill="#FCFCFC"
                    />
                    <path
                      d="M10.5 19H14.5"
                      stroke="#FCFCFC"
                      strokeLinecap="round"
                    />
                  </svg>
                </span>
                <span className={styles.name}>
                  <p>
                    {imgType == 0
                      ? t("Passport 1st")
                      : imgType == 1
                      ? t("Passport 2nd")
                      : t("Selfie")}
                  </p>
                </span>
              </div>
              {selfieStatus === 1 && (
                <div
                  className={styles.right_side}
                  style={{
                    padding: "12px",
                    color: "#E9770E",
                    background: "rgba(233, 119, 14, 0.08)",
                    borderRadius: "1000px",
                    fontSize: "14px",
                    fontWeight: "600",
                  }}
                >
                  {t("Pending")}
                </div>
              )}
              {selfieStatus === 2 && (
                <div
                  className={styles.right_side}
                  style={{
                    padding: "12px",
                    color: "#00B4A0",
                    background: "rgba(0, 180, 160, 0.08)",
                    borderRadius: "1000px",
                    fontSize: "14px",
                    fontWeight: "600",
                  }}
                >
                  {t("Successful")}
                </div>
              )}
              {selfieStatus === 3 && (
                <div
                  className={styles.right_side}
                  style={{
                    padding: "12px",
                    color: "#F63D68",
                    background: "rgba(246, 61, 104, 0.08)",
                    borderRadius: "1000px",
                    fontSize: "14px",
                    fontWeight: "600",
                  }}
                >
                  {t("Reject")}
                </div>
              )}
            </div>
          ) : null}
        </div>
      </div>
      <Drawer
        open={isModalOpen}
        anchor={window.innerWidth < 600 ? "bottom" : "right"}
        onClose={toggleDrawer(false)}
        PaperProps={{
          className: styles.paper,
        }}
      >
        <div className={styles.account_drawer}>
          <div className={styles.close_icon} onClick={toggleDrawer(false)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={16}
              height={16}
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M12 4.00003L4 12M3.99997 4L11.9999 12"
                stroke="#51525C"
                strokeLinecap="round"
              />
            </svg>
          </div>
          <div className={styles.top_drawer}>
            <div className={styles.drawer_header}>
              <span className={styles.icon}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={"2.5vh"}
                  height={"2.4vh"}
                  viewBox="0 0 25 24"
                  fill="none"
                >
                  <path
                    d="M4.5 6V19C4.5 20.6569 5.84315 22 7.5 22H17.5C19.1569 22 20.5 20.6569 20.5 19V9C20.5 7.34315 19.1569 6 17.5 6H4.5ZM4.5 6V5"
                    stroke="#FCFCFC"
                  />
                  <circle cx="12.5" cy="13" r="3" stroke="#FCFCFC" />
                  <path
                    d="M18.5 5.99904V6.49904H19V5.99904H18.5ZM16.2172 2.32516L16.1464 1.83019L16.2172 2.32516ZM5.41959 3.86767L5.34888 3.3727H5.34888L5.41959 3.86767ZM5.57107 6.49904H18.5V5.49904H5.57107V6.49904ZM19 5.99904V4.30506H18V5.99904H19ZM16.1464 1.83019L5.34888 3.3727L5.49031 4.36265L16.2879 2.82014L16.1464 1.83019ZM5.34888 3.3727C4.5749 3.48327 4 4.14613 4 4.92798H5C5 4.64378 5.20897 4.40284 5.49031 4.36265L5.34888 3.3727ZM19 4.30506C19 2.78369 17.6525 1.61503 16.1464 1.83019L16.2879 2.82014C17.1915 2.69105 18 3.39224 18 4.30506H19ZM5.57107 5.49904C5.25568 5.49904 5 5.24337 5 4.92798H4C4 5.79565 4.70339 6.49904 5.57107 6.49904V5.49904Z"
                    fill="#FCFCFC"
                  />
                  <path
                    d="M10.5 19H14.5"
                    stroke="#FCFCFC"
                    strokeLinecap="round"
                  />
                </svg>
              </span>
              {t("Images")}
            </div>
            <div className={styles.drawer_body}>
              {isLoading ? (
                <CircularProgress color="secondary" />
              ) : (
                <img src={imageData} width={"100%"} />
              )}
            </div>
          </div>
        </div>
      </Drawer>
    </div>
  );
}
